#import "../../../../common/graphql/EntityDocumentsFields.graphql"

query AttachableApprovalExtendedDocuments(
  $first: Int
  $after: Cursor
  $entityApprovalId: UUID
  $documentTypeId: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  attachableApprovalExtendedDocuments(
    first: $first
    after: $after
    entityApprovalId: $entityApprovalId
    documentTypeId: $documentTypeId
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      ...EntityDocumentsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
